import classNames from 'classnames';
import { ReactNode, useId } from 'react';
import Typography from '@alltrails/core/components/Typography';
import setDenaliAttribute from '../../utils/setDenaliAttribute';
import SelectionChip from './SelectionChip';
import type { Chip } from './SelectionChip';
import styles from './styles/styles.module.scss';

type SelectionChipsProps = {
  allowDeselect?: boolean;
  className?: string;
  chips: Chip[];
  isMultiSelect?: boolean;
  selectedChips: Chip[];
  title: string;
  errorText?: ReactNode;
  onChange: (selectedChip: Chip) => void;
  onChipDoubleClick?: (chip: Chip) => void;
};

const SelectionChips = ({
  allowDeselect,
  chips,
  className,
  errorText,
  isMultiSelect,
  onChange,
  onChipDoubleClick,
  selectedChips,
  title
}: SelectionChipsProps) => {
  const titleId = useId();

  return (
    <div {...setDenaliAttribute('SelectionChips')} className={classNames(styles.parentContainer, className)}>
      <h3 className={styles.visuallyHidden} id={titleId}>
        {title}
      </h3>
      <div className={styles.selectionChipContainer} role={isMultiSelect || allowDeselect ? 'group' : 'radiogroup'} aria-labelledby={titleId}>
        {chips.map(chip => {
          const isSelected = selectedChips.some(selectedChip => selectedChip.id === chip.id);
          return (
            <SelectionChip
              chip={chip}
              key={chip.id}
              isMultiSelect={isMultiSelect}
              allowDeselect={allowDeselect}
              onClick={onChange}
              onDoubleClick={onChipDoubleClick}
              leadingIcon={chip.icon}
              isSelected={isSelected}
              name={title}
            />
          );
        })}
      </div>
      {errorText && (
        <Typography variant="text100" color="error" component="div">
          {errorText}
        </Typography>
      )}
    </div>
  );
};

export default SelectionChips;
